import _ from "lodash";

export const checkDataIsEmpty = (data) => {

  if (typeof data === 'number') {
    return false;

  } else {
    return (
      data === ''
      || data === null
      || data === undefined
      || data.length === 0
      || Object.keys(data).length === 0
    );
  }
}

export const checkEmail = (email) => {
  // 檢查email格式是否正確
  const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return isValidEmail.test(email);
}

export const checkPassword = (str) => {
  // 檢查是否包含數字和英文字母，且長度大於等於8
  const isValidPassword = /^(?=.*[0-9])(?=.*[a-zA-Z]).{8,}$/;
  return isValidPassword.test(str);
}

export const validateForm = (validateRule, formData) => {
  let isError = false;
  const errorMsg = {};

  Object.entries(validateRule).forEach(el => {
    const currentValue = _.get(formData, el[1].field);
    const currentIsError = checkDataIsEmpty(currentValue);
    let showErrorMsg;

    if (el[1].required === true) {
      showErrorMsg = currentIsError;
      errorMsg[el[0]] = currentIsError;
    } else {
      showErrorMsg = false;
      errorMsg[el[0]] = false;
    }

    isError = isError || showErrorMsg;
  })

  return {
    isError,
    errorMsg
  }

}

export const validateFormHaveEmail = (validateRule, formData) => {
  let isError = false;
  const errorMsg = {};

  Object.entries(validateRule).forEach(el => {
    const currentValue = _.get(formData, el[1].field);
    const currentIsError = checkDataIsEmpty(currentValue);
    let showErrorMsg;

    if (el[1].required === true) {
      showErrorMsg = currentIsError;
      errorMsg[el[0]] = currentIsError;
    } else {
      showErrorMsg = false;
      errorMsg[el[0]] = false;
    }

    isError = isError || showErrorMsg;
  })

  //check user_email
  if (validateRule.hasOwnProperty('user_email') && formData['user_email'] !== '') {
    const isValidEmail = checkEmail(formData['user_email'])
    isError = isError || !isValidEmail;
    errorMsg['user_email_valid'] = !isValidEmail;

  } else {
    errorMsg['user_email_valid'] = false;
  }

  return {
    isError,
    errorMsg
  }

}